import { useEffect, useState } from 'react';
import { useProfile } from './getQueries';

const usePermission = ({ study }) => {
  const [studyPermission, setStudyPermission] = useState({
    edit: false,
    preview: false,
    shareWithParticipants: false,
    addCollaborators: false,
    stopCollectingResponses: false,
    archive: false,
    delete: false,
    isUploaded: false,
  });
  const [analysisPermission, setAnalysisPermission] = useState({
    runAnalysis: false,
  });
  const [isPending, setIsPending] = useState(true);

  const { data: user, isPending: userIsPending } = useProfile();

  useEffect(() => {
    if (userIsPending) {
      return;
    }
    // debugger;
    if (study) {
      const isOwner = user?.id === study?.owner_id;
      const hasEditPermission =
        study?.members
          ?.find((member) => member?.user_email === user?.email)
          ?.permissions?.includes('edit') || false;

      const isArchived = study?.status === 'archived' || false;
      const isInactive = study?.status === 'inactive' || false;
      const isDraft = study?.status === 'draft' || false;
      // Uploaded/secondary studies have is_primary === false - disable edit/preview/share features
      const isUploaded = study?.is_primary === false;

      setStudyPermission({
        edit: (isOwner || (hasEditPermission && !isArchived)) && !isUploaded,
        preview: !isArchived && !isInactive && !isDraft && !isUploaded,
        shareWithParticipants: !isArchived && !isInactive && !isDraft && !isUploaded,
        addCollaborators: isOwner || (hasEditPermission && !isArchived),
        stopCollectingResponses: (isOwner || hasEditPermission) && !isUploaded,
        archive: isOwner || hasEditPermission,
        delete: isOwner,
        // Expose isUploaded flag for tooltip messages
        isUploaded,
      });
      setAnalysisPermission({
        runAnalysis: isOwner || hasEditPermission,
      });
    }
    setIsPending(false);
  }, [user, userIsPending, study]);

  return { data: { studyPermission, analysisPermission }, isPending };
};

export default usePermission;
